import { postRawRequest } from '../../httpClient';
import type { IClipSubtitleV1Params } from './clip-subtitle-v1-request';

const ONE_HOUR_MS = 3_600_000;

export async function clipSubtitleV1Api({
  subtitleId,
  force,
}: IClipSubtitleV1Params): Promise<Response> {
  const params: string[] = [];
  if (force) {
    params.push('force=true');
  }
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return postRawRequest({
    path: `/sys/subtitles/${subtitleId}/clip/v1${query}`,
    options: { timeout: ONE_HOUR_MS },
  });
}
